module.exports = __webpack_public_path__ + "img/cq3.fa00cad5.jpg";